import moment from 'moment'

export const DIRECT_BILLING_HELP_TEXT = "Ajusta el monto como desees. Una vez que se programe, el día y la cuenta quedarán fijos por los próximos 6 meses.";

// TODO: definir la URL de las políticas de domiciliación en el Centro de Ayuda
export const DIRECT_BILLING_POLICIES_URL = "";

const DIRECT_BILLING_ROOT_FIELDS = [
  'can_auto_invest',
  'can_modify_direct_billing',
  'can_change_direct_billing_charge_details',
  'can_reactivate_direct_billing',
  'direct_billing_reactivation_available_at',
];

// Arma el plan del inversionista a partir de la respuesta de getInvestorPlansInfo,
// incluyendo las banderas de reglas de la domiciliación (abono automático).
export function mapInvestorPlansInfo(data) {
  const plan = { ...data.plan };
  DIRECT_BILLING_ROOT_FIELDS.forEach(field => {
    plan[field] = data[field];
  });
  plan.suspendedDirectBillingBankAccount = data.suspended_direct_billing_bank_account;
  return plan;
}

// Requiere que el componente tenga `investorPlan` (data o prop) armado con mapInvestorPlansInfo.
export default {
  data() {
    return {
      directBillingHelpText: DIRECT_BILLING_HELP_TEXT,
      directBillingPoliciesUrl: DIRECT_BILLING_POLICIES_URL,
    }
  },
  computed: {
    hasDirectBilling() {
      return this.investorPlan?.autoinvest_deposits === 1 || this.investorPlan?.autoinvest_deposits === true;
    },
    isDirectBillingSuspended() {
      return !!this.investorPlan?.suspendedDirectBillingBankAccount;
    },
    // en el alta inicial todo es editable; ya configurada, el monto se bloquea si está suspendida
    canEditDirectBillingAmount() {
      return !this.hasDirectBilling || !!this.investorPlan.can_modify_direct_billing;
    },
    // el día de cobro y la cuenta comparten el mismo candado de 6 meses
    canEditDirectBillingChargeDetails() {
      return !this.hasDirectBilling || !!this.investorPlan.can_change_direct_billing_charge_details;
    },
    // suspender siempre se puede; reactivar solo si el backend lo permite
    canToggleDirectBilling() {
      return !this.isDirectBillingSuspended || !!this.investorPlan.can_reactivate_direct_billing;
    },
    // aviso debajo del toggle mientras no se pueda reactivar; el backend manda la fecha solo en ese caso
    directBillingReactivationMessage() {
      const availableAt = this.investorPlan?.direct_billing_reactivation_available_at;
      if (!availableAt) {
        return null;
      }
      // "YYYY-MM-DD" en hora de México: se parsea como fecha local para que no se recorra un día
      const date = moment(availableAt, 'YYYY-MM-DD').locale("es").format('D [de] MMMM [de] YYYY');
      return `Por tu seguridad, pusimos en pausa tus abonos automáticos hasta el ${date}.`;
    },
  },
  methods: {
    // los errores 400 de domiciliación llegan como string JSON
    getDirectBillingErrorMessage(e, fallback = "No ha sido posible actualizar la información, intente más tarde.") {
      const data = e?.response?.data;
      if (typeof data === 'string' && data.length > 0) {
        return data;
      }
      return data?.message || data?.error || fallback;
    },
  },
}
